import axiosInstanceProxy from "./useAxiosClient/index"
import axios from "axios"

const axiosInstance = axios.create({
  baseURL: process.env.GATSBY_PROXY_URL || "https://preprodproxy.efpa.es/",
})

const loginToken = () => {
  if (typeof window !== "undefined") return axiosInstanceProxy.post("/token/")
  return {}
}

axiosInstance.interceptors.request.use(
  config => {
    if (!config.url || config.url === null || config.url === undefined) {
      const error = new Error('URL no válida: undefined o null')
      error.code = 'INVALID_URL'
      error.config = config
      return Promise.reject(error)
    }
    
    if (typeof config.url !== 'string' || config.url.trim() === '') {
      const error = new Error('URL no válida: cadena vacía')
      error.code = 'INVALID_URL'
      error.config = config
      return Promise.reject(error)
    }
    
    if (config.url.includes('undefined') || config.url.includes('null')) {
      const error = new Error(`URL no válida: contiene valores undefined/null - ${config.url}`)
      error.code = 'INVALID_URL'
      error.config = config
      return Promise.reject(error)
    }
    
    const token = typeof window !== "undefined" ? localStorage.getItem("token") : ""
    if (token) {
      config.headers["Authorization"] = "Bearer " + token
    }
    return config
  },
  error => Promise.reject(error)
)

axiosInstance.interceptors.response.use(
  res => res,
  async err => {
    const originalConfig = err.config
    
    if (err.code === 'INVALID_URL') return Promise.reject(err)
    if (err.code === 'ERR_NETWORK' || err.code === 'ERR_BAD_REQUEST') return Promise.reject(err)
    
    if (err.response && err.response.status === 401 && !originalConfig._retry) {
      originalConfig._retry = true
      try {
        const response = await loginToken()
        if (response?.data?.access) {
          localStorage.setItem("token", response.data.access)
          originalConfig.headers = originalConfig.headers || {}
          originalConfig.headers["Authorization"] = "Bearer " + response.data.access
          return axios(originalConfig)
        }
      } catch (_error) {
        return Promise.reject(_error)
      }
    }
    return Promise.reject(err)
  }
)

export default axiosInstance